import { supabase } from '../lib/supabase'
import type { TipologiaImpianto } from '@praticheenergia/domain'

export const TIPI_DOCUMENTO = ['ultima_dichiarazione', 'crediti_accise', 'relazione_tecnica'] as const
export type TipoDocumento = (typeof TIPI_DOCUMENTO)[number]

const MIME_AMMESSI = ['application/pdf', 'image/jpeg', 'image/png']
const DIMENSIONE_MASSIMA = 20 * 1024 * 1024

/** Le altre officine richiedono i dati accise dell'anno precedente e la relazione tecnica. */
export function documentiRichiesti(tipologia: TipologiaImpianto): TipoDocumento[] {
  return tipologia === 'altre_officine' ? ['crediti_accise', 'relazione_tecnica'] : []
}

export interface RigaDocumento {
  readonly id: number
  readonly tipo: TipoDocumento
  readonly nomeFile: string
  readonly dimensione: number
  readonly percorso: string
}

export async function elencaDocumenti(impiantoId: number): Promise<RigaDocumento[]> {
  const { data, error } = await supabase
    .from('documento_impianto')
    .select('id, tipo, nome_file, dimensione, percorso')
    .eq('impianto_id', impiantoId)
  if (error) throw new Error(error.message)
  return (data ?? []).map((r: Record<string, unknown>) => ({
    id: r.id,
    tipo: r.tipo,
    nomeFile: r.nome_file,
    dimensione: r.dimensione,
    percorso: r.percorso,
  })) as RigaDocumento[]
}

export async function caricaDocumento(impiantoId: number, tipo: TipoDocumento, file: File) {
  if (file.size > DIMENSIONE_MASSIMA) throw new Error('Il file supera i 20 MB')
  if (!MIME_AMMESSI.includes(file.type)) throw new Error('Formato non ammesso: usa PDF, JPEG o PNG')

  const percorso = `impianti/${impiantoId}/${tipo}/${crypto.randomUUID()}-${file.name}`
  const { error: errUpload } = await supabase.storage.from('documenti').upload(percorso, file)
  if (errUpload) throw new Error(errUpload.message)

  const { error } = await supabase.from('documento_impianto').insert({
    impianto_id: impiantoId,
    tipo,
    percorso,
    nome_file: file.name,
    dimensione: file.size,
  })
  if (error) throw new Error(error.message)
}
